<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-sending *ngIf="sending"></app-sending>

  <app-select
    [options]="periods"
    [(ngModel)]="period"
    (change)="getList(period)"
  ></app-select>

  <div class="master-info-link-wrap">
    <a class="master-info-link" (click)="openInfoDialog()">各種ボタンについて</a>
  </div>

  <app-action-grid
    [data]="data"
    [loading]="loading"
    [rowSelection]="rowSelection"
    [columns]="columns"
    minusHeight="60"
    [actionButtons]="actionButtons"
    [cellClasses]="cellClasses"
    (actionCommit)="actionCommit($event)"
    [exportExcelButton]="true"
  ></app-action-grid>
</app-main-contents>

<app-dialog
  *ngIf="dialogOpen"
  [title]="'銀行API処理履歴'"
  widthSize="large"
  [hideCommitButton]="true"
  [hideCancelButton]="true"
  (cancel)="dialogOpen = false"
>
  <div *ngIf="!history.length && !loading">履歴はありません</div>
  <div *ngFor="let item of history" class="flex">
    <div>{{ item.updatedDatetimeUi }}</div>
    <div>
      <a style="cursor: pointer" (click)="historyDetail = item.content; detailDialogOpen = true">
        [{{ item.actionName }}]{{ item.resultCd }}
      </a>
    </div>
    <div>{{ item.resultMessage }}</div>
  </div>
</app-dialog>

<app-dialog
  class="detail-dialog"
  *ngIf="detailDialogOpen"
  [hideCommitButton]="true"
  [hideCancelButton]="true"
  (cancel)="detailDialogOpen = false"
>
  <pre>{{ historyDetail | json }}</pre>
</app-dialog>

<app-dialog
  *ngIf="bankTranDateAlertDialogOpen"
  [title]="'※直近の口座振替日マスタが未登録です'"
  [hideCancelButton]="true"
  commitButtonText="閉じる"
  (commit)="closeBankTranDateAlertDialog()"
  (cancel)="closeBankTranDateAlertDialog()"
>
  <div>
    現在月から2か月先までの口座振替日マスタが未登録です。<br />
    未登録: {{ missingBankTranDates.join('、') }}
  </div>
</app-dialog>

<app-dialog
  *ngIf="infoDialogOpen"
  [title]="'各種ボタンについて'"
  widthSize="medium"
  [hideCommitButton]="true"
  cancelButtonText="閉じる"
  (cancel)="closeInfoDialog()"
>
  <div class="info-row">
    <span class="info-label">振替依頼送信</span>
    <span class="info-body">金融機関システムに口座振替対象のデータを送信する</span>
    <span class="info-body">金融機関スケジュールで定められた期日までに、対象の行を選択して送信を実行する</span>
    <span class="info-body">送信したくない行は選択しなければ送信されない</span>
    <span class="info-body">【注意】送信完了後の「追加送信」は行わないこと</span>
    <span class="info-body">【修正したい場合】一度キャンセル（システム部への対応依頼が必要）した後に、再実行する</span>
  </div>
  <div class="info-row">
    <span class="info-label">処理履歴確認</span>
    <span class="info-body">振替依頼送信のログを確認する(イレギュラー発生時用)</span>
  </div>
  <div class="info-row">
    <span class="info-label">振替結果受信・入金消込</span>
    <span class="info-body">金融機関システムから振替結果を受信し、Suppliで入金消込を行う</span>
    <span class="info-body">銀行スケジュールで定められた日の16:00頃から実行可能となる（行選択不要、受信は送信データの結果を全件受信する）</span>
    <span class="info-body">入金消込結果が「スキップ」となった行は消込対象が見つからないので、対応が必要</span>
  </div>
  <div class="info-row">
    <span class="info-label">Excelエクスポート</span>
    <span class="info-body">一覧データをExcel出力する（行選択は不要）</span>
  </div>
</app-dialog>
